"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = prepareObject;

var _l10n = _interopRequireDefault(require("../../../common/l10n"));

var _imgIssuer = _interopRequireDefault(require("./imgIssuer"));

var _imgProduct = _interopRequireDefault(require("./imgProduct"));

var _img = _interopRequireDefault(require("./img"));

function prepareObject(_ref) {
  var data = _ref.data,
      theme = _ref.theme,
      disabled = _ref.disabled;
  return {
    id: data.id,
    balance: !isNaN(data.balance) ? data.balance : null,
    number: data.number || '',
    name: data.name || '',
    currency: _l10n["default"].t(data.currency || ''),
    imgIssuer: typeof data.imgIssuer === 'function' ? data.imgIssuer() : (0, _imgIssuer["default"])(data.number),
    imgProduct: typeof data.imgProduct === 'function' ? data.imgProduct() : (0, _imgProduct["default"])(data.product),
    img: typeof data.img === 'function' ? data.img() : (0, _img["default"])(data.img),
    imgFallback: typeof data.imgFallback === 'function' ? data.imgFallback() : '#FFF',
    theme: theme,
    disabled: disabled
  };
}